import { BiEdit } from 'react-icons/bi';
import ModalBtn from "../../molecules/modalButton/view";
import { createSubscription, updateSubscription, initializeUserConfig } from '../../../usecases/user-operations-usecase';
import './style.css';
import { Col, Form } from 'react-bootstrap';
import PlanDisplay from '../../molecules/PlanDisplay/view';
import SubscriptionInfoCard from '../../molecules/SubscriptionInfoCard/view';
import ButtonLoading from '../../atoms/buttonLoading/view';
import { updatePlemsiToken, getPlemsiToken } from '../../../usecases/plemsi-token-usecase';
import { useContext, useState } from 'react';
import { SubscriptionStatus, SubscriptionPaymentMethod, EmptyArray } from '../../../domain/suscriptions/model';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { getSubscriptionById } from '../../../usecases/user-operations-usecase';
import SubscriptionSettingsForm from '../SubscriptionSettingsForm/view';


import TabSwitcher from '../../molecules/TabSwitcher/view';
import UserDocumentPackages from '../UserDocumentPackages/view';


function OperationUserEdit({ data }) {

    const [plemsiToken, setPlemsiToken] = useState('');
    const [newPlemsiToken, setNewPlemsiToken] = useState('');
    const [tokenError, setTokenError] = useState('');
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(SubscriptionPaymentMethod.CREDIT_CARD);
    const [subscription, setSubscription] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(SubscriptionStatus.ACTIVE);
    const [isChangingPlan, setIsChangingPlan] = useState(false);

    const handleOpen = async () => {
        getSubscriptionById(data.id).then(response => {
            if (response && response.data) {
                const subData = response.data;
                setSubscription(subData);
                setSelectedPaymentMethod(subData.payment_method || SubscriptionPaymentMethod.CREDIT_CARD);
                setSelectedStatus(subData.status || SubscriptionStatus.ACTIVE);
                setIsChangingPlan(false);

                if (subData.status === SubscriptionStatus.ACTIVE) {
                    getPlemsiToken(data.id).then(tokenData => {
                        if (tokenData && tokenData !== EmptyArray) {
                            setPlemsiToken(tokenData.token);
                            setNewPlemsiToken(tokenData.token);
                        } else {
                            setPlemsiToken('');
                            setNewPlemsiToken('');
                        }
                    }).catch(error => {
                        console.error('Error fetching Plemsi Token:', error);
                    });
                }
            } else {
                setSubscription(null);
            }
        }).catch(error => {
            console.error('Error fetching subscription:', error);
            setSubscription(null);
        });
    };

    const handleSetPlan = async (plan) => {
        const planId = plan[0].id;

        if (subscription) {
            // Update existing subscription
            try {
                await updateSubscription({
                    users_id: data.id,
                    plan_id: planId,
                    aditional_info: {} // Reset additional info on plan change
                });
                dispatchCustomEvent('popup', { message: 'Plan actualizado correctamente.' });
                // Refresh subscription data to show new plan and limits
                handleOpen();
            } catch (error) {
                console.error('Error updating plan:', error);
                dispatchCustomEvent('popup', { message: 'Error actualizando plan.', type: 'error' });
            }
        } else {
            // Create new subscription
            const subscriptionPayload = {
                users_id: data.id,
                plan_id: planId,
                status: SubscriptionStatus.PENDING,
                payment_method: selectedPaymentMethod,
                aditional_info: {}
            };

            createSubscription(subscriptionPayload).then(response => {
                window.location.reload();
            }).catch(error => {
                console.error('Error creating subscription:', error);
            });
        }
    };

    const handleSavePlemsiToken = async () => {
        setTokenError(''); // Clear previous errors

        if (!newPlemsiToken.trim()) {
            setTokenError('El token de Plemsi no puede estar vacío.');
            dispatchCustomEvent('loading-btn');
            return;
        }

        updatePlemsiToken(data.id, newPlemsiToken.trim()).then(() => {
            dispatchCustomEvent('popup', { message: 'Token actualizado correctamente.', type: 'info' });
        }).catch(error => {
            console.error('Error creating Plemsi Token:', error);
            dispatchCustomEvent('popup', { message: 'Error actualizando Token.', type: 'error' });
        }).finally(() => {
            dispatchCustomEvent('loading-btn');
        });

    };

    const handlePaymentMethodChange = async (e) => {
        const newMethod = e.target.value;
        setSelectedPaymentMethod(newMethod);

        if (subscription?.status === SubscriptionStatus.ACTIVE) {
            try {
                await updateSubscription({
                    users_id: data.id,
                    payment_method: newMethod
                });
                dispatchCustomEvent('popup', { message: 'Método de pago actualizado correctamente.' });
                setSubscription(prev => ({ ...prev, payment_method: newMethod }));
            } catch (error) {
                console.error('Error updating payment method:', error);
                dispatchCustomEvent('popup', { message: 'Error actualizando método de pago.', type: 'error' });
            }
        }
    };

    const handleStatusChange = async (e) => {
        const newStatus = e.target.value;
        setSelectedStatus(newStatus);

        if (subscription) {
            try {
                await updateSubscription({
                    users_id: data.id,
                    status: newStatus
                });
                dispatchCustomEvent('popup', { message: 'Estado de suscripción actualizado correctamente.' });
                setSubscription(prev => ({ ...prev, status: newStatus }));
            } catch (error) {
                console.error('Error updating status:', error);
                dispatchCustomEvent('popup', { message: 'Error actualizando estado.', type: 'error' });
            }
        }
    };

    const handleInitializeConfig = async () => {
        try {
            await initializeUserConfig(data.id);
            dispatchCustomEvent('popup', { message: 'Configuración inicial de usuario completada correctamente.' });
        } catch (error) {
            console.error('Error initializing user config:', error);
            dispatchCustomEvent('popup', { message: 'Error inicializando configuración.', type: 'error' });
        }
    };

    const tabs = [
        {
            name: "Configuración",
            component: () => (
                <SubscriptionSettingsForm
                    userName={data?.name}
                    subscription={subscription}
                    selectedPaymentMethod={selectedPaymentMethod}
                    onPaymentMethodChange={handlePaymentMethodChange}
                    selectedStatus={selectedStatus}
                    onStatusChange={handleStatusChange}
                    newPlemsiToken={newPlemsiToken}
                    onPlemsiTokenChange={setNewPlemsiToken}
                    tokenError={tokenError}
                    onSavePlemsiToken={handleSavePlemsiToken}
                    isChangingPlan={isChangingPlan}
                    onToggleChangingPlan={() => setIsChangingPlan(!isChangingPlan)}
                    onSetPlan={handleSetPlan}
                    onInitializeConfig={handleInitializeConfig}
                />
            )
        },
        {
            name: "Paquetes de Documentos",
            component: () => <UserDocumentPackages userId={data.id} />
        }
    ];

    return (
        <ModalBtn
            id={"edit-user-" + data?.email}
            type="action"
            title={<BiEdit />}
            onClick={handleOpen}
        >
            <h3 style={{ marginBottom: '20px' }}>Configuración para {data?.name}</h3>

            {
                subscription === null ?
                    <Form>
                        <Col>
                            <p>**Para continuar con la configuración debes asignarle un plan al usuario**</p>
                            <PlanDisplay SetSelectedPlan={handleSetPlan}></PlanDisplay>
                        </Col>
                    </Form> :
                    <TabSwitcher tabs={tabs} />
            }
        </ModalBtn>
    )
}


export default OperationUserEdit;
